module.exports = __webpack_public_path__ + "static/media/national-cancer-institute-JvPmIB4Hnx4-unsplash(1).8c1f2dfc.jpg";